import { Form, Formik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import { ERROR_MSG, ROLE } from "../../constants/common";
import { RESET_LOADER, SET_LOADER } from "../../constants/contexConstant";
import {
    GET_ALL_PLANT_ENDPOINT,
    GET_PLANT_BY_QUERY_ENDPOINT,
    SALES_SUMMARY_DATA_ENDPOINT,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import { checkIsAllowed } from "../../helpers/helpers";
import request from "../../services/request";
import Container from "../../shared/Container";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import SalesSummaryCard from "../../shared/ui/Cards/SalesSummaryCard";
import { Carousel } from "../../shared/ui/Carousel";
import DrawerAndModalWrapper from "../../shared/ui/Drawer/DrawerAndModalWrapper";
import FormikLabeledInput from "../../shared/ui/Form/FormikLabeledInput";
import { plantFilterValidationSchema } from "../../shared/ui/Form/schema";
import BellReminders from "../admin/bell-reminder";
import DashBoardTable from "./DashBoardTable";
import { getTotalSalesData, renderSales } from "./HeroDetails";
const DashBoard = () => {
    const { dispatch, state } = useContextState();
    const [data, setData] = useState([]);
    const [paginationData, setPaginationData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(
        !checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN]) ? "Mine" : "All"
    );
    const [ProposalGen, setProposalGen] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [formData, setFormData] = useState({
        propertyName: "",
        searchName: "",
    });

    const handleSearchValueChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }, []);

    const handleRemoveSearchValue = (name) => {
        setFormData((prev) => {
            const updated = { ...prev, [name]: "" };
            fetchAllPlantData(0, 6, updated);
            return updated;
        });
    };

    const handleProposalGenChange = useCallback(() => {
        setProposalGen((prev) => !prev);
    }, []);

    const fetchAllPlantData = useCallback(
        async (pageNumber = 0, pageSize = 6, formdata = formData) => {
            const number = isNaN(pageNumber)
                ? Number(pageNumber?.selected)
                : pageNumber;
            try {
                let endpoint = "";
                if (formdata?.propertyName) {
                    endpoint = `${GET_PLANT_BY_QUERY_ENDPOINT}?columnName=name&searchPattern=${
                        formdata?.propertyName
                    }&pageNumber=${number}&pageSize=${pageSize}&sortBy=true&assignee=${
                        selectedFilter === "Mine"
                    }&proposalGenerated=${ProposalGen}`;
                } else if (formdata?.searchName) {
                    endpoint = `${GET_PLANT_BY_QUERY_ENDPOINT}?columnName=plantId&searchPattern=${
                        formdata?.searchName
                    }&pageNumber=${number}&pageSize=${pageSize}&sortBy=true&assignee=${
                        selectedFilter === "Mine"
                    }&proposalGenerated=${ProposalGen}`;
                } else {
                    endpoint = `${GET_ALL_PLANT_ENDPOINT}?pageNumber=${number}&pageSize=${pageSize}&sortBy=true&assignee=${
                        selectedFilter === "Mine"
                    }&proposalGenerated=${ProposalGen}`;
                }

                dispatch({ type: SET_LOADER });
                const data = await request.authGet({ endpoint });
                setData(data?.data?.plants);
                setPaginationData({
                    isFirst: data?.data?.isFirst,
                    isLast: data?.data?.isLast,
                    pageNumber: data?.data?.pageNumber,
                    pageCount: data?.data?.totalPages,
                });

                setShowModal(false);
                dispatch({ type: RESET_LOADER });
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                toast.error(typeof error === "string" ? error : ERROR_MSG);
            }
        },
        [selectedFilter, formData, ProposalGen, dispatch]
    );
    const [salesData, setSalesData] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            const endpoint = SALES_SUMMARY_DATA_ENDPOINT;
            const data = await request.authGet({ endpoint });

            setSalesData(data?.data);
        };
        fetchData();
    }, []);

    useEffect(() => {
        fetchAllPlantData();
    }, [selectedFilter, ProposalGen]);

    const totalSalesData = getTotalSalesData(salesData);

    return (
        <div className="bg-blue-700 min-h-screen lg:flex lg:justify-center lg:items-stretch lg:gap-3 pt-[6rem] lg:w-full   lg:mt-[10rem] md:min-h-full lg:bg-white">
            <Container className="w-full  p-2 mb-3 lg:w-2/5 xl:w-1/2 2xl:w-2/3 lg:rounded-3xl lg:shadow-xl lg:border lg:mx-0  ">
                <div className=" flex  flex-col xl:flex-row md:gap-2 px-1">
                    <div className="w-full lg:w-full xl:w-[50%]">
                        <Carousel
                            slides={renderSales(salesData, currentSlide)}
                            headclass="h-full"
                            autoSlide={true}
                            flexPos="justify-start lg:justify-center"
                            autoSlideInterval={3000}
                            nav={false}
                            currentSlide={currentSlide}
                            handleSlideChange={(index) =>
                                setCurrentSlide(index)
                            }
                        />
                    </div>
                    <div className=" hidden lg:block  lg:w-full xl:w-[50%]">
                        <SalesSummaryCard
                            className="bg-linear-blue-white rounded-2xl"
                            name={"Total Sales Summary"}
                            totalSales={totalSalesData.totalSales}
                            salesData={[
                                {
                                    value: totalSalesData.oneDaySales,
                                    label: "1D Sales",
                                },
                                {
                                    value: totalSalesData.oneWeekSales,
                                    label: "7D Sales",
                                },
                                {
                                    value: totalSalesData.oneMonthSales,
                                    label: "30D Sales",
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className="hidden lg:flex w-full ">
                    <BellReminders />
                </div>
            </Container>
            <Container className="py-3 md:py-1 lg:py-0 lg:pb-0 md:px-1 min-h-svh rounded-t-2.5  lg:min-h-full md:mb-4 bg-white min-w-full lg:min-w-max lg:bg-transparent lg:flex lg:items-center lg:w-1/5 xl:w-1/4 lg:mx-0  lg:h-[550px] lg:overflow-y-scroll lg:rounded-3xl  lg:shadow-xl lg:border lg:px-2 ">
                <div className="lg:hidden">
                    <SalesSummaryCard
                        className="bg-linear-blue-white rounded-2xl"
                        name={"Total Sales Summary"}
                        totalSales={totalSalesData.totalSales}
                        salesData={[
                            {
                                value: totalSalesData.oneDaySales,
                                label: "1D Sales",
                            },
                            {
                                value: totalSalesData.oneWeekSales,
                                label: "7D Sales",
                            },
                            {
                                value: totalSalesData.oneMonthSales,
                                label: "30D Sales",
                            },
                        ]}
                    />
                </div>

                <div className="h-full">
                    <DashBoardTable
                        selectedFilter={selectedFilter}
                        onFilterChange={setSelectedFilter}
                        onSearchValueChange={handleSearchValueChange}
                        handleChange={handleProposalGenChange}
                        data={data}
                        roles={state?.user?.roles}
                        handleRemoveSearchValue={handleRemoveSearchValue}
                        formData={formData}
                        ProposalGen={ProposalGen}
                        setShowModal={setShowModal}
                        paginationData={paginationData}
                        onPageChange={fetchAllPlantData}
                    />
                </div>
            </Container>
            <DrawerAndModalWrapper
                isOpen={showModal}
                onClose={() => setShowModal((prev) => !prev)}
                modalContentClass="bg-white"
                showClose={false}
                childrenClassName="rounded-t-4"
                chidrenContainerClass={"px-0 mx-0 min-w-full"}
                drawerContentClassName="min-h-[30vh] w-full rounded-t-4"
            >
                <div className="bg-white w-full rounded-t-2 px-4 py-3">
                    <div className="flex justify-end items-center lg:hidden">
                        <div
                            role="button"
                            onClick={() => setShowModal((prev) => !prev)}
                        >
                            <P className="text-lg my-1">
                                <RxCross2 />
                            </P>
                        </div>
                    </div>
                    <Formik
                        initialValues={formData}
                        enableReinitialize
                        validationSchema={plantFilterValidationSchema}
                        onSubmit={(values) => {
                            fetchAllPlantData(0, 6, values);
                        }}
                    >
                        <Form className="flex w-full flex-col justify-center items-center gap-2">
                            <div className="w-full">
                                <FormikLabeledInput
                                    name="propertyName"
                                    placeholder="Property Name"
                                    type="text"
                                    onChange={handleSearchValueChange}
                                />
                            </div>
                            <div className="w-full">
                                <FormikLabeledInput
                                    name="searchName"
                                    placeholder="Search by ID"
                                    type="text"
                                    onChange={handleSearchValueChange}
                                />
                            </div>
                            <Button
                                type="submit"
                                className="w-full !rounded-2.5 mb-5 sm:mb-3"
                            >
                                Apply Filters
                            </Button>
                        </Form>
                    </Formik>
                </div>
            </DrawerAndModalWrapper>
        </div>
    );
};

export default DashBoard;
